import React, { useState } from 'react';
import { Step1Basics } from './Step1Basics';
import { Step2Goals } from './Step2Goals';
import { Step3Experience } from './Step3Experience';
import { Step4Learning } from './Step4Learning';
import { Step5Contact } from './Step5Contact';
import { Step6Blueprint } from './Step6Blueprint';
import type { DesignerState } from './DesignerFlow';
const initialState: DesignerState = {
  eventName: '',
  eventType: '',
  locationType: '',
  location: '',
  attendees: '',
  length: '',
  date: '',
  goals: [],
  successCriteria: '',
  audienceType: '',
  energyLevel: '',
  format: '',
  comfortLevel: '',
  foodAlcohol: '',
  learningThemes: [],
  wellnessActivities: [],
  constraints: '',
  name: '',
  email: '',
  company: '',
  role: '',
  planningFor: '',
  brandedHub: ''
};
export const STEP_NAMES = ['Event Basics', 'Goals', 'Attendee Experience', 'Learning + Wellness', 'Contact Capture', 'Your Blueprint'];
export function useDesignerSteps() {
  const [step, setStep] = useState(1);
  const [data, setData] = useState<DesignerState>(initialState);
  const updateData = (updates: Partial<DesignerState>) => {
    setData(prev => ({
      ...prev,
      ...updates
    }));
  };
  const nextStep = () => setStep(prev => Math.min(prev + 1, 6));
  const prevStep = () => setStep(prev => Math.max(prev - 1, 1));
  return {
    step,
    data,
    updateData,
    nextStep,
    prevStep,
    setStep
  };
}
export function DesignerSteps({
  step,
  data,
  updateData,
  nextStep,
  prevStep
}: {
  step: number;
  data: DesignerState;
  updateData: (u: Partial<DesignerState>) => void;
  nextStep: () => void;
  prevStep: () => void;
}) {
  return <>
      {step === 1 && <Step1Basics data={data} updateData={updateData} onNext={nextStep} data-id="element-2481" />}
      {step === 2 && <Step2Goals data={data} updateData={updateData} onNext={nextStep} onBack={prevStep} data-id="element-2482" />}
      {step === 3 && <Step3Experience data={data} updateData={updateData} onNext={nextStep} onBack={prevStep} data-id="element-2483" />}
      {step === 4 && <Step4Learning data={data} updateData={updateData} onNext={nextStep} onBack={prevStep} data-id="element-2484" />}
      {step === 5 && <Step5Contact data={data} updateData={updateData} onNext={nextStep} onBack={prevStep} data-id="element-2485" />}
      {step === 6 && <Step6Blueprint data={data} data-id="element-2486" />}
    </>;
}